<template>
    <div
        class="cc-summary-page"
        :class="{
            [`active-${activeTab}`]: true,
        }"
    >
        <header-v2 class="cc-header-v2"/>
        <div class="cc-summary-container">
            <div class="cc-summary-tabs">
                <div
                    v-for="tabItem in tabList"
                    :key="tabItem.name"
                    :class="{
                        'cc-summary-tab-content': true,
                        'active': activeTab === tabItem.name,
                        'hidden': !checkTabVisible(tabItem),
                    }"
                    @click="handleClickTab(tabItem.name)"
                >
                    <veui-icon
                        class="tab-item-icon"
                        :name="tabItem.icon"
                    />{{ tabItem.label }}
                </div>
            </div>
            <div class="cc-summary-content">
                <div
                    v-show="cardList.length > 0"
                    :key="activeTab"
                    class="cc-summary-main"
                >
                    <div
                        class="cc-summary-main-left"
                        :class="{'multi': mainCardList}"
                    >
                        <!-- mainCardList 模式：多卡片上下排列 -->
                        <template v-if="mainCardList">
                            <div
                                v-for="(card, index) in mainCardList"
                                :key="index"
                                class="cc-summary-main-card medium"
                                :class="{
                                    'disabled': card.markType === 'wait' || !checkTabVisible(card),
                                }"
                                @click="handleClickCard(card)"
                            >
                                <div class="cc-card-preview">
                                    <div
                                        class="summary-card-thumbnail"
                                        :style="{
                                            backgroundImage: `url(${card.thumbnail})`,
                                        }"
                                    >
                                        <video
                                            :src="card.previewUrl"
                                            :poster="card.thumbnail"
                                            playsInline="true"
                                            class="card-video"
                                            preload="auto"
                                            autoplay
                                            muted
                                            loop
                                        ></video>
                                    </div>
                                    <div
                                        v-if="checkShowFree(card)"
                                        class="summary-card-mark-free"
                                    >限时免费</div>
                                </div>
                                <div class="summary-card-text">
                                    <div class="summary-card-text-title">
                                        {{ card.title }}
                                        <div
                                            v-if="!checkTabVisible(card)
                                                && card.routeName && card.markType !== 'wait'"
                                            :class="`title-mark title-mark-noauth`"
                                        >内测中</div>
                                        <div
                                            v-else-if="card.markType"
                                            :class="`title-mark title-mark-${card.markType}`"
                                        >{{ card.markText }}</div>
                                    </div><br>
                                    <div class="summary-card-text-desc">{{ card.desc }}</div>
                                </div>
                            </div>
                        </template>
                        <!-- 默认模式：单个 mainCard -->
                        <div
                            v-else
                            ref="summaryCard"
                            class="cc-summary-main-card large"
                            :class="{
                                'disabled': !checkTabVisible(mainCard),
                            }"
                            @click="handleClickCard(mainCard)"
                        >
                            <div class="cc-card-preview">
                                <div
                                    class="summary-card-thumbnail"
                                    :style="{
                                        backgroundImage: `url(${mainCard.thumbnail})`,
                                    }"
                                >
                                    <video
                                        :src="mainCard.previewUrl"
                                        :poster="mainCard.thumbnail"
                                        playsInline="true"
                                        class="card-video"
                                        preload="auto"
                                        autoplay
                                        muted
                                        loop
                                    ></video>
                                </div>
                                <div
                                    v-if="checkShowFree(mainCard)"
                                    class="summary-card-mark-free"
                                >限时免费</div>
                            </div>
                            <div class="summary-card-text">
                                <div class="summary-card-text-title">
                                    {{ mainCard.title }}
                                    <div
                                        v-if="!checkTabVisible(mainCard)
                                            && mainCard.routeName && mainCard.markType !== 'wait'"
                                        :class="`title-mark title-mark-noauth`"
                                    >内测中</div>
                                    <div
                                        v-else-if="mainCard.markType"
                                        :class="`title-mark title-mark-${mainCard.markType}`"
                                    >{{ mainCard.markText }}</div>
                                </div><br>
                                <div
                                    :ref="`${activeTab}-cardMainDesc`"
                                    class="summary-card-text-desc"
                                >{{ mainCard.desc }}</div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="cardList.length <= 4"
                        :class="{
                            'cc-summary-main-right': true,
                            'medium': cardList.length <= 2,
                            'small': cardList.length > 2,
                            [`num-${cardList.length}`]: true,
                        }"
                    >
                        <div
                            v-for="(cardItem, index) in cardList"
                            :key="cardItem.title"
                            class="cc-summary-main-card"
                            :class="{
                                'small': cardList.length > 2,
                                'medium': cardList.length <= 2,
                                'disabled': cardItem.markType === 'wait' || !checkTabVisible(cardItem),
                            }"
                            @click="handleClickCard(cardItem)"
                        >
                            <div class="cc-card-preview">
                                <div
                                    class="summary-card-thumbnail"
                                    :style="{
                                        backgroundImage: `url(${cardItem.thumbnail})`,
                                    }"
                                >
                                    <video
                                        :src="cardItem.previewUrl"
                                        :poster="cardItem.thumbnail"
                                        playsInline="true"
                                        class="card-video"
                                        preload="auto"
                                        autoplay
                                        muted
                                        loop
                                    ></video>
                                </div>
                                <div
                                    v-if="checkShowFree(cardItem)"
                                    class="summary-card-mark-free"
                                >限时免费</div>
                            </div>
                            <div class="summary-card-text">
                                <div class="summary-card-text-title">
                                    {{ cardItem.title }}
                                    <div
                                        v-if="!checkTabVisible(cardItem)
                                            && cardItem.routeName && cardItem.markType !== 'wait'"
                                        :class="`title-mark title-mark-noauth`"
                                    >内测中</div>
                                    <div
                                        v-else-if="cardItem.markType"
                                        :class="`title-mark title-mark-${cardItem.markType}`"
                                    >{{ cardItem.markText }}</div>
                                </div><br>
                                <div
                                    :ref="`${activeTab}-cardSmallDesc-${index}`"
                                    class="summary-card-text-desc"
                                    @mouseenter="handleShowTooltip(`${activeTab}-cardSmallDesc-${index}`, cardItem)"
                                    @mouseleave="showTooltip = false"
                                >{{ cardItem.desc }}</div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-else
                        :class="{
                            'cc-summary-main-right': true,
                            'medium': cardList.length <= 2,
                            'small': cardList.length > 2,
                            [`num-${cardList.length}`]: true,
                        }"
                    >
                        <div
                            v-for="(cardItem, index) in cardList.slice(0, 3)"
                            :key="cardItem.title"
                            class="cc-summary-main-card"
                            :class="{
                                'small': cardList.length > 2,
                                'medium': cardList.length <= 2,
                                'disabled': cardItem.markType === 'wait' || !checkTabVisible(cardItem),
                            }"
                            @click="handleClickCard(cardItem)"
                        >
                            <div class="cc-card-preview">
                                <div
                                    class="summary-card-thumbnail"
                                    :style="{
                                        backgroundImage: `url(${cardItem.thumbnail})`,
                                    }"
                                >
                                    <video
                                        :src="cardItem.previewUrl"
                                        :poster="cardItem.thumbnail"
                                        playsInline="true"
                                        class="card-video"
                                        preload="auto"
                                        autoplay
                                        muted
                                        loop
                                    ></video>
                                </div>
                                <div
                                    v-if="checkShowFree(cardItem)"
                                    class="summary-card-mark-free"
                                >限时免费</div>
                            </div>
                            <div class="summary-card-text">
                                <div class="summary-card-text-title">
                                    {{ cardItem.title }}
                                    <div
                                        v-if="!checkTabVisible(cardItem)
                                            && cardItem.routeName && cardItem.markType !== 'wait'"
                                        :class="`title-mark title-mark-noauth`"
                                    >内测中</div>
                                    <div
                                        v-else-if="cardItem.markType"
                                        :class="`title-mark title-mark-${cardItem.markType}`"
                                    >{{ cardItem.markText }}</div>
                                </div><br>
                                <div
                                    :ref="`${activeTab}-cardSmallDesc-${index}`"
                                    class="summary-card-text-desc"
                                    @mouseenter="handleShowTooltip(`${activeTab}-cardSmallDesc-${index}`, cardItem)"
                                    @mouseleave="showTooltip = false"
                                >{{ cardItem.desc }}</div>
                            </div>
                        </div>
                        <div class="cc-summary-main-card-multi">
                            <div
                                v-for="cardItem in cardList.slice(3)"
                                :key="cardItem.title"
                                class="cc-summary-main-card-multi-item"
                                :class="{
                                    [`main-card-multi-${cardList.slice(3).length}`]: true,
                                }"
                                @click="handleClickCard(cardItem)"
                            >
                                <div
                                    ref="multiThumbnail"
                                    class="cc-summary-main-card-multi-item-thumbnail"
                                    :style="{
                                        backgroundImage: `url(${cardItem.thumbnail})`,
                                    }"
                                ></div>
                                <div class="cc-summary-main-card-multi-item-text">{{ cardItem.title }}</div>
                            </div>
                        </div>
                    </div>
                    <veui-tooltip
                        overlay-class="card-desc-tooltip"
                        ui="reverse"
                        position="bottom"
                        :target="tooltipTarget"
                        :open="showTooltip"
                        :hide-delay="1500"
                    >{{ tooltipText }}</veui-tooltip>
                </div>
            </div>
        </div>
        <footer-v2/>
        <digital-human-tip-dialog ref="tipDialog"/>
    </div>
</template>

<script>
import {Icon, Tooltip} from 'veui';
import {summaryTabList, summaryContentMap} from '@/layouts/config/configV2';
import HeaderV2 from '@/layouts/components/HeaderV2.vue';
import FooterV2 from '@/layouts/components/FooterV2.vue';
import DigitalHumanTipDialog from '@/component/DigitalHumanTipDialog';
import {checkHagRole, checkItemValid, checkLimitRole} from '@/common/util';
import {MODE_STORAGE_KEY} from '@/common/storageKeys';

const DEFAULT_ACTIVE_TAB = 'video';

export default {
    name: 'cc-summary',
    inject: ['alsLog'],
    data() {
        return {
            showTooltip: false,
            tooltipTarget: '',
            tooltipText: '',
            activeTab: this.$route.params.activeTab || DEFAULT_ACTIVE_TAB,
            tabList: summaryTabList,
            summaryContentMap
        };
    },
    components: {
        HeaderV2,
        FooterV2,
        'veui-icon': Icon,
        'veui-tooltip': Tooltip,
        'digital-human-tip-dialog': DigitalHumanTipDialog
    },
    mounted() {
        // 每次登陆后都清除之前的返回旧版的标记
        // window.localStorage.removeItem('style_click_old');
        window.sessionStorage.setItem('style_click_old', '0');

        this.alsLog({
            f1: 'summaryPagePv',
            f2: 'show',
            f11: this.activeTab
        });
        this.tryShowTip();
    },
    computed: {
        activeBg() {
            let activeItem = this.tabList.find(item => item.name === this.activeTab);
            return activeItem?.background;
        },
        activeSummary() {
            return this.summaryContentMap[this.activeTab] || {};
        },
        hags() {
            return this.$store.state.app.userInfo.bizHags;
        },
        userInfo() {
            return this.$store.state.app.userInfo;
        },
        isOuterUser() {
            return this.$store.state.app.userInfo.isOuterUser;
        },
        mainCard() {
            const mainCard = this.activeSummary.mainCard || {};
            // 处理 limitRole 权限，无权限的显示"即将上线"
            if (mainCard.limitRole && !checkLimitRole(this.hags, mainCard.limitRole)) {
                mainCard.markType = 'wait';
                mainCard.markText = '即将上线';
                mainCard.routeName = '';
            }
            return mainCard;
        },
        mainCardList() {
            const mainCardList = this.activeSummary.mainCardList || null;
            if (!mainCardList) {
                return null;
            }
            // 处理 limitRole 权限，无权限的显示"即将上线"
            return mainCardList.map(item => {
                if (item.limitRole && !checkLimitRole(this.hags, item.limitRole)) {
                    item.markType = 'wait';
                    item.markText = '即将上线';
                    item.routeName = '';
                }
                return item;
            }).filter((item, index, arr) => {
                if (!item.mutexGroup) {
                    return true;
                }
                // mutexGroup 同组只保留第一张可见的；都不可见时保留组内第一张
                const group = arr.filter(i => i.mutexGroup === item.mutexGroup);
                const firstVisible = group.find(i => checkItemValid(i, {hags: this.hags, userInfo: this.userInfo}));
                if (firstVisible) {
                    return item === firstVisible;
                }
                return item === group[0];
            });
        },
        cardList() {
            const cardList = this.activeSummary.cardList || [];
            let list = cardList.map(item => {
                if (item.authorizedRole) {
                    item.hide = !checkHagRole(this.hags, item.authorizedRole);
                }
                else if (item.antiAuthorizedRole) {
                    item.hide = this.hags[item.antiAuthorizedRole];
                }
                else if (item.anyMatch) {
                    item.hide = !checkItemValid(item, {hags: this.hags, userInfo: this.userInfo});
                }
                else {
                    item.hide = item.hideCard;
                }
                // 不在小流量名单内的无权限使用
                if (item.limitRole && !checkLimitRole(this.hags, item.limitRole)) {
                    item.markType = 'wait';
                    item.markText = '即将上线';
                    item.routeName = '';
                }
                return item;
            });
            return list.filter(item => !item.hide);
        }
    },
    watch: {
        $route(to) {
            let newTab = to.params.activeTab || DEFAULT_ACTIVE_TAB;
            if (this.activeTab !== newTab) {
                this.activeTab = newTab;
                this.alsLog({
                    f1: 'summaryPagePv',
                    f2: 'show',
                    f11: this.activeTab
                });
                this.tryShowTip();
            }
        }
    },
    methods: {
        // 数字人 tab 首次进入展示能力升级提示弹窗
        tryShowTip() {
            if (this.activeTab === 'digitalhuman') {
                this.$refs.tipDialog && this.$refs.tipDialog.tryShow('digitalhuman');
            }
        },
        // 判断某个导航选项是否有权限查看
        checkTabVisible(item) {
            const {hags, userInfo} = this;
            return checkItemValid(item, {hags, userInfo});
        },
        // 判断是否显示【限时免费】标记
        checkShowFree(item) {
            const {hags, isOuterUser, checkTabVisible} = this;
            if (!item.freeLimit) {
                return false;
            }
            // 免费用户
            if (hags.generate_not_pay || hags.digital_human_pay_inner_list) {
                return false;
            }
            // 无权限的不打标
            if (!checkTabVisible(item) && item.routeName && item.markType !== 'wait') {
                return false;
            }
            // mock 临时去掉
            return false;
            // pass用户，或者uc 无资质
            // return isOuterUser || false;
        },
        handleClickTab(event) {
            if (event === this.activeTab) {
                return;
            }
            this.alsLog({
                f1: 'summaryPagePv',
                f2: 'click',
                f11: event
            });
            console.log(event);
            this.activeTab = event;
            // 把路由换成相应类别的，保持刷新或者回退的话停留在当前tab
            this.$router.push({
                name: 'homeV2',
                params: {
                    activeTab: event
                }
            });
            this.tryShowTip();
        },
        handleClickCard(cardInfo) {
            if (!this.checkTabVisible(cardInfo)) {
                return false;
            }
            this.alsLog({
                f1: 'summaryCardClick',
                f2: 'click',
                f11: cardInfo.title
            });
            if (cardInfo.isEmpty) {
                return;
            }
            const userId = this.$store.state.app.hairuo?.userid || this.$route.params.userid || '';
            // 跨应用外链跳转（如 digital-agent 子应用），支持 {userid} 占位符
            if (cardInfo.externalPath) {
                const target = cardInfo.externalPath.replace('{userid}', userId);
                window.open(target, '_blank', 'noreferrer');
                return;
            }
            if (cardInfo.link) {
                const url = cardInfo.link.replace('${userid}', userId);
                if (cardInfo.authorizedRole === 'qingduo_v3_agent_image') {
                    window.localStorage.setItem(MODE_STORAGE_KEY, 'image');
                }
                window.open(url, cardInfo.externalTarget || '_blank');
            }
            else if (cardInfo.routeName) {
                this.$router.push({
                    name: cardInfo.routeName
                });
            }
        },
        handleShowTooltip(target, cardInfo) {
            this.tooltipTarget = this.$refs[target];
            if (cardInfo.desc) {
                this.tooltipText = cardInfo.desc;
            }
            if (this.tooltipText && !cardInfo.isEmpty) {
                this.showTooltip = true;
            }
        }
    }
};

</script>

<style lang="less" scoped>
@summary-headerHeight: 64px;
@footer-height: 28px;

// 容器左右padding
@containerPadding: 16px;

// 容器去除高度，固定
@summary-container-reduce: @summary-headerHeight + @footer-height;

// tab区域占据空间，固定
@summary-tab-height: 44px;
@summary-tab-top: 12px;
@summary-tab-own: @summary-tab-height + @summary-tab-top;

// 内容区占据空间，固定
@mainPaddingTop: 24px;
@mainPadding: 32px;
@summary-main-reduce: @summary-container-reduce + @summary-tab-own;

// 卡片内容除去间距后的高度应减数，固定
@card-reduce: @summary-main-reduce + @mainPaddingTop + @mainPadding;
// 卡片内部padding，固定
@cardPadding: 16px;
// 大卡预览图比例，固定
@preview-ratio: 628 / 488;
// 小卡预览图比例，固定
@preview-ratio-small: 286 / 178;
// 中卡预览图比例，固定
@preview-ratio-medium: 628 / 178;

// 卡片间距，动态
@card-gap-std: 24px;
// 文案高度，动态
@text-height-std: 72px;

// 根据高度折算计算宽度应该用比例 * 100vh - 应减数值，动态。常规的用于大于800
@card-width-reduce-std: (@card-reduce + @cardPadding* 2 + @text-height-std) * @preview-ratio - @cardPadding* 2;
@preview-height-small-reduce-std: (@card-reduce + @card-gap-std + @cardPadding* 4 + @text-height-std * 2) / 2;
@preview-width-small-reduce-std: @preview-height-small-reduce-std * @preview-ratio-small;
@card-width-reduce-right-std: @preview-width-small-reduce-std * 2 - @cardPadding* 4 - @card-gap-std;

// 根据宽度折算，计算高度应该用比例 * 100vw - 应减数值，动态。常规的用于大于800
@card-width-reduce-std: (@card-reduce + @cardPadding* 2 + @text-height-std) * @preview-ratio - @cardPadding* 2;
@preview-height-small-reduce-std: (@card-reduce + @card-gap-std + @cardPadding* 4 + @text-height-std * 2) / 2;
@preview-width-small-reduce-std: @preview-height-small-reduce-std * @preview-ratio-small;
@card-width-reduce-right-std: @preview-width-small-reduce-std * 2 - @cardPadding* 4 - @card-gap-std;

// 低于600的，锁定数字
@card-gap-min: 18px;
@text-height-min: 60px;
@card-width-reduce-min: (@card-reduce + @cardPadding* 2 + @text-height-min) * @preview-ratio - @cardPadding* 2;
@preview-height-small-reduce-min: (@card-reduce + @card-gap-min + @cardPadding* 4 + @text-height-min * 2) / 2;
@preview-width-small-reduce-min: @preview-height-small-reduce-min * @preview-ratio-small;
@card-width-reduce-right-min: @preview-width-small-reduce-min * 2 - @cardPadding* 4 - @card-gap-min;

// 由于文案大小自适应，高度也是变化的
@card-gap-auto4: calc(~"6px + 2vh");
@text-height-auto4: calc(~"12px + 8vh");

@text-height-std: 76px;

// 尺寸的独立出来前置写，方便核对，且按分辨率防止优先级覆盖
// 常规尺寸（大于800）
.cc-summary-page {
    .cc-summary-content {
        height: auto;
        max-width: 100%;
        overflow: auto;
        &::-webkit-scrollbar {
            display: none;
        }
    }
    .cc-summary-main {
        min-width: fit-content;
        height: calc(100vh - @summary-main-reduce);
        gap: @card-gap-std;
        &-left,
        &-right {
            height: calc(100vh - @card-reduce);
            // 需要保持封面图的比例，计算宽度
            width: calc(100vh * @preview-ratio
                    - (@card-reduce + @cardPadding* 2 + @text-height-std) * @preview-ratio
                    + @cardPadding* 2);
            gap: @card-gap-std;
            border-radius: 28px;
            .cc-summary-main-card-multi-item-text {
                font-weight: 500;
                font-size: 22px!important;
            }
            .cc-summary-main-card {
                height: calc(50% - @card-gap-std / 2);
                width: calc(50% - @card-gap-std / 2);
                border-radius: 28px;
                &-multi {
                    display: flex;
                    flex-direction: column;
                    height: calc(50% - @card-gap-std / 2);
                    width: calc(50% - @card-gap-std / 2);
                    background: transparent;
                    padding: 0;
                    &-item {
                        flex: 1;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        padding: 16px;
                        margin-bottom: 16px;
                        background: #FFF;
                        border-radius: 16px;
                        cursor: pointer;
                        &-thumbnail {
                            width: 82px;
                            height: 100%;
                            background-size: 100% 100%;
                        }
                        &-text {
                            font-size: 18px;
                            line-height: 26px;
                            margin-left: 16px;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        &:hover {
                            box-shadow: 0 4px 28px 1px #0047C20A, 0 5px 30px 1px #0047C20D, 0 6px 32px 2px #0047C20F;
                        }
                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                    .main-card-multi-2 {
                        .cc-summary-main-card-multi-item-thumbnail {
                            width: 165px;
                        }
                        .cc-summary-main-card-multi-item-text {
                            font-weight: 500;
                            font-size: 22px;
                            line-height: 26px;
                            color: @dls-color-gray-9;
                        }
                    }
                }
            }
            .cc-card-preview {
                width: calc(100% - 0);
                height: calc(100% - @text-height-std);
                position: relative;
            }
            .summary-card-mark-free {
                position: absolute;
                top: 0;
                right: 0;
                background: linear-gradient(97.77deg, #FFDA90 0%, #FFF0D2 36.86%, #FFEBC3 73.72%, #FFD98E 110.57%);
                border-radius: 0px 10px 0px 10px;
                font-size: 12px;
                line-height: 18px;
                padding: 4px 10px;
                display: flex;
                // 临时隐藏
                display: none;
                align-items: center;
                justify-content: center;
                color: #D88F00;
            }
        }
        &-right {
            width: calc(100vh * @preview-ratio-small
                - (
                    @card-reduce + @card-gap-std + @cardPadding* 4 + @text-height-std * 2
                    ) / 2 * @preview-ratio-small * 2
                + @cardPadding* 4
                + @card-gap-std
            );
        }
    }
    .summary-card-text {
        height: @text-height-std;
        overflow: hidden;
        .summary-card-text-title {
            margin-top: 16px;
            margin-bottom: 4px;
            font-size: 22px;
            line-height: 32px;
            .title-mark {
                padding: 4px 6px;
                font-size: 12px;
            }
        }
        .summary-card-text-desc {
            font-size: 14px;
            line-height: 20px;
        }
    }
}
// 设置默认兜底方案：如果比较高就用宽度适配；如果比较宽就用高度适配

// 600 - 800，字号和padding自动计算，其他尺寸也相应的做减法操作计算出来
@media screen and (max-height: 800px) {
    .autoSizeByHeight(100vh, @card-gap-auto4, @text-height-auto4, 100vh);
}
// 最小尺寸（600最低）
@media screen and (max-height: 600px) {
    .autoSizeByHeight(600px, @card-gap-min, @text-height-min, 600px);
}

// 如果宽度较小的时候，要按照宽度适配，高度可留空，确保每个方向都不要滚动
// 每个方向都分为偏高或者偏宽两种比例下，按照宽度或者高度自适应，但是不同尺寸下的比例不同，所以需要分别定义
// 700档
@media screen and (min-aspect-ratio: 1440/800) and (min-height: 700px) {
    .autoSizeByHeight(100vh, @card-gap-auto4, @text-height-auto4, 100vh);
}
@media screen and (max-aspect-ratio: 1440/800) and (min-height: 700px) {
    .autoSizeByWidth(100vw);
}
// 需要把比例变化到下一阶段之间的补齐
@media screen and (min-aspect-ratio: 1440/800) and (max-aspect-ratio: 1697/900) and (min-height: 800px) {
    .autoSizeByHeight(100vh, @card-gap-std, @text-height-std, 800px);
}

// 800档
@media screen and (min-aspect-ratio: 1697/900) and (min-height: 800px) {
    .autoSizeByHeight(100vh, @card-gap-std, @text-height-std, 800px);
}
@media screen and (max-aspect-ratio: 1697/900) and (min-height: 800px) {
    .autoSizeByWidth(100vw);
}
@media screen and (min-aspect-ratio: 1697/900) and (max-aspect-ratio: 1955/1000) and (min-height: 900px) {
    .autoSizeByHeight(100vh, @card-gap-std, @text-height-std, 800px);
}

// 900档
@media screen and (min-aspect-ratio: 1955/1000) and (min-height: 900px) {
    .autoSizeByHeight(100vh, @card-gap-std, @text-height-std, 800px);
}
@media screen and (max-aspect-ratio: 1955/1000) and (min-height: 900px) {
    .autoSizeByWidth(100vw);
}
@media screen and (min-aspect-ratio: 1955/1000) and (max-aspect-ratio: 2134/1000) and (min-height: 980px) {
    .autoSizeByHeight(100vh, @card-gap-std, @text-height-std, 800px);
}
// 设置自适应的最大场景，最大宽度1920，对应的高度980是标准
@media screen and (min-width: 1920px) and (min-height: 980px) {
    .autoSizeByWidth(1920px);
}
@media screen and (min-width: 1920px) and (max-height: 980px) and (min-height: 800px) {
    .autoSizeByHeight(100vh, @card-gap-std, @text-height-std, 800px);
}
@media screen and (min-width: 1920px) and (max-height: 800px) and (min-height: 600px) {
    .autoSizeByHeight(100vh, @card-gap-auto4, @text-height-auto4, 100vh);
}

// 低于1240且比例小
@media screen and (max-width: 1240px) and (max-height: 680px) {
    // .autoSizeByWidth(1080px);
    .autoSizeByHeight(600px, @card-gap-min, @text-height-min, 600px);
}
// 低于1240且比例小
@media screen and (max-width: 1240px) and (min-height: 680px) {
    .autoSizeByWidth(1000px);
}

.cc-summary-page {
    position: relative;
    height: 100vh;
    min-width: 1240px;
    overflow-y: hidden;
    overflow-x: auto;
    justify-content: center;
    align-items: start;
    flex-direction: column;
    transition: background-image 2s ease 0s;
    background: #ECF5FF no-repeat center center fixed;
    background-size: cover;
    &::-webkit-scrollbar {
        display: none;
    }
    .cc-header-v2 {
        width: 100%;
        height: @summary-headerHeight;
        z-index: 2;
    }

    &.active-video {
        background-image: url('https://qiaojiang.bj.bcebos.com/fe/static/images/bgvideo.png');
    }
    &.active-image {
        background-image: url('https://qiaojiang.bj.bcebos.com/fe/static/images/bgimage.png');
    }
    &.active-text {
        background-image: url('https://qiaojiang.bj.bcebos.com/fe/static/images/bgtext2.png');
    }
    &.active-digitalhuman {
        background-image: url('https://qiaojiang.bj.bcebos.com/fe/static/images/bgdigital.png');
    }
    .bg-video {
        margin: 0 auto;
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
        // todo 动画时长修改，背景链接修改
        transition: all 2s ease 0s;
        background: #fff no-repeat center center fixed;
        background-size: cover;
        &.type-video {
            background-image: url('https://qiaojiang.bj.bcebos.com/fe/static/images/bgvideo.png');
        }
        &.type-image {
            background-image: url('https://qiaojiang.bj.bcebos.com/fe/static/images/bgimage.png');
        }
        &.type-text {
            background-image: url('https://qiaojiang.bj.bcebos.com/fe/static/images/bgtext.png');
        }
        &.type-digitalhuman {
            background-image: url('https://qiaojiang.bj.bcebos.com/fe/static/images/bgdigital.png');
        }
    }
    .cc-summary-container {
        width: 100vw;
        height: calc(100vh - @summary-container-reduce);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 3;
        padding: 0 @containerPadding;
        flex-direction: column;
    }
    .cc-summary-tabs {
        margin: @summary-tab-top auto 0;
        height: @summary-tab-height;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        // display: none;
        .cc-summary-tab-content {
            height: @summary-tab-height;
            padding: 0 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: @dls-color-gray-9;
            cursor: pointer;
            font-weight: 500;

            border-radius: 40px;
            font-size: 18px;
            line-height: 26px;
            margin: 0 8px;
            transition: all 0.1s ease 0s;
            .tab-item-icon {
                visibility: hidden;
                font-size: 22px;
                margin-right: 8px;
                min-width: 24px;
            }
            &:hover,
            &.active {
                background: #fff;
                .tab-item-icon {
                    color: #4D79FF;
                    visibility: visible;
                }
            }
            &.active {
                .tab-item-icon {
                    color: #3A5BFD;
                }
            }
            &.hidden {
                display: none;
            }
        }
    }
    /deep/ .footer {
        padding-top: 2px;
        height: 30px;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
    }
}
.cc-summary-main {
    padding: @mainPaddingTop @mainPadding @mainPadding;
    width: auto;
    display: flex;
    justify-content: center;
    align-items: space-between;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: hidden;
    overflow-y: auto;
    border-radius: 28px;
    &::-webkit-scrollbar {
        display: none;
    }
    &-left,
    &-right {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        flex-direction: row;
        border-radius: 28px;
        &.multi {
            flex-direction: column;
            flex-wrap: nowrap;
            align-items: stretch;
            gap: @card-gap-std;
        }
        .cc-summary-main-card {
            background: #fff;
            border-radius: 28px;
            overflow: visible;
            padding: 16px;
            cursor: pointer;
            position: relative;
            &.large {
                height: 100%;
                width: 100%;
            }
            &.large-multi {
                width: 100%;
                flex: 1;
                min-height: 0;
            }
            &.medium {
                width: 100%;
            }
            &:hover {
                box-shadow: 0px 6px 32px 2px #0047C20F;
                box-shadow: 0px 4px 28px 1px #0047C20A,
                    0px 5px 30px 1px #0047C20D,
                    0px 6px 32px 2px #0047C20F;

            }
            &.disabled {
                cursor: not-allowed;
            }
        }
    }
}
.multi {
    .cc-card-preview {
        .summary-card-thumbnail {
            background-size: auto 100%;
        }
    }
}
.cc-card-preview {
    .summary-card-thumbnail {
        height: 100%;
        width: 100%;
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center center;
        overflow: hidden;
        border-radius: 16px;

        transition: background-image 0.2s ease 0s;
    }
    .card-video {
        width: 100%;
        height: 100%;
        visibility: hidden;
    }
    &:hover {
        .card-video {
            // visibility: visible;
        }
    }
}
.summary-card-text {
    .summary-card-text-title {
        font-weight: 500;
        color: @dls-color-gray-9;
        position: relative;
        display: inline-block;
        .title-mark {
            position: absolute;
            left: calc(100% + 4px);
            top: 50%;
            transform: translateY(-50%);
            padding: 4px 6px;
            border-radius: 6px 6px 6px 0px;
            font-size: 12px;
            line-height: 1;
            background: #668BCC1A;
            color: #545B66;
            font-weight: 400;
            white-space: nowrap;
            &-new {
                color: #3A5BFD;
                background: linear-gradient(271.37deg, #F0EBFF -0.08%, #E6FCFF 99.45%);
                font-weight: 500;
            }
        }
    }
    .summary-card-text-desc {
        font-weight: 400;
        color: @dls-color-gray-7;
        word-break: break-all;
        white-space: nowrap;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
    }
}

.card-desc-tooltip {
    /deep/ .veui-tooltip {
        max-width: unset;
    }
}
@media screen and (max-height: 600px) {
    .cc-summary-page {
        .cc-summary-container {
            height: calc(100vh - 104px);
        }
        /deep/ .footer {
            &.v2 {
                height: 40px;
                padding-top: 12px;
            }
        }
    }
}

// 按高度自适应的代码抽离成方法
.autoSizeByHeight(@fullHeight, @autoGap, @autoTextHeight, @stdHeight) {
    .cc-summary-page {
        .cc-summary-main {
            height: calc(@fullHeight - @summary-main-reduce);
            gap: @autoGap;
            &-left,
            &-right {
                height: calc(@fullHeight - @card-reduce);
                // 需要保持封面图的比例，计算宽度
                width: calc(@fullHeight * @preview-ratio
                    - (@card-reduce + @cardPadding* 2 + @autoTextHeight) * @preview-ratio
                    + @cardPadding* 2);
                gap: @autoGap;
                border-radius: 22px;
                .cc-summary-main-card,
                .cc-summary-main-card-multi {
                    height: calc(50% - @autoGap / 2);
                    width: calc(50% - @autoGap / 2);
                    border-radius: 22px;
                    &.small {
                        max-width: calc(50% - @autoGap / 2 - 0.5px);
                    }
                }
                .cc-card-preview {
                    height: calc(100% - @autoTextHeight);
                }
            }
            &-right,
            &-right.small,
            &-right.medium {
                width: calc(@fullHeight * @preview-ratio-small
                    - (
                        @card-reduce + @autoGap + @cardPadding* 4 + @autoTextHeight * 2
                        ) / 2 * @preview-ratio-small * 2
                    + @cardPadding* 4
                    + @autoGap
                );
            }
        }
        .summary-card-text {
            height: @autoTextHeight;
            .summary-card-text-title {
                margin-top: calc(@stdHeight / 50);
                font-size: calc(16px + (@stdHeight - 600px) * 1.5 / 50);
                line-height: calc(@stdHeight / 25);
            }
            .summary-card-text-desc {
                font-size: calc(6px + @stdHeight / 100);
                line-height: calc(4px + @stdHeight / 50);
            }
        }
    }
}

// 把屏幕较窄、较高的比例下，按宽度自适应的代码，抽成函数，按照屏幕纵横比、多种场景下，都使用本代码
.autoSizeByWidth(@fullWidth) {
    .cc-summary-page {
        .cc-summary-container {
            max-width: 100vw;
        }
        .cc-summary-main {
            width: calc(@fullWidth - @containerPadding * 2);
            height: auto;
            gap: @card-gap-std;
            &-left,
            &-right {
                width: calc(@fullWidth / 2 - @containerPadding - @mainPadding - @card-gap-std / 2);
                // 高度用右边的反推
                height: calc(
                    (((@fullWidth / 2 - @containerPadding - @mainPadding - @card-gap-std * 1.5) / 2 - @cardPadding * 2)
                    / @preview-ratio-small + @text-height-std + @cardPadding * 2)
                    * 2 + @card-gap-std
                );
                gap: @card-gap-std;
                border-radius: 28px;
                .cc-summary-main-card,
                .cc-summary-main-card-multi {
                    height: calc(50% - @card-gap-std / 2);
                    width: calc(50% - @card-gap-std / 2);
                    border-radius: 28px;
                    &.small {
                        max-width: calc(50% - @card-gap-std / 2 - 0.5px);
                    }
                }
                .cc-card-preview {
                    width: calc(100% - 0);
                    height: calc(100% - @text-height-std);
                }
            }
            // 右侧的高度要与左侧保持一致，但是为了保证图片比例，宽度要基于高度的逻辑反向再计算一遍
            &-right.medium {
                width: calc(@fullWidth / 2 - @containerPadding - @mainPadding - @card-gap-std / 2);
            }
            &-right.small {
                width: calc(@fullWidth / 2 - @containerPadding - @mainPadding - @card-gap-std / 2);
            }
            // 右边固定宽高，左边的固定高度、动态宽度，因为左侧的
            &-left {
                width: calc(
                    ((((@fullWidth / 2 - @containerPadding - @mainPadding - @card-gap-std * 1.5) / 2 - @cardPadding * 2)
                        / @preview-ratio-small + @text-height-std + @cardPadding * 2)
                        * 2 + @card-gap-std - @text-height-std - @cardPadding * 2
                    ) * @preview-ratio + @cardPadding * 2
                );
            }
        }
        .summary-card-text {
            height: @text-height-std;
            overflow: hidden;
            .summary-card-text-title {
                margin-top: 16px;
                margin-bottom: 4px;
                font-size: 22px;
                line-height: 32px;
                .title-mark {
                    padding: 4px 6px;
                    font-size: 12px;
                }
            }
            .summary-card-text-desc {
                font-size: 14px;
                line-height: 20px;
            }
        }
    }
}


// 低于1240的，container不要限制最大宽度
@media screen and (max-width: @screen-min-width) {
    .cc-summary-page {
        .cc-summary-container {
            max-width: 100%;
            width: 100%;
            .cc-summary-content {
                max-width: unset;
                width: auto;
                .cc-summary-main {
                    padding-left: 0;
                    padding-right: 0;
                    &-right {
                        .cc-summary-main-card-multi {
                            &-item-thumbnail {
                                width: 60px !important;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
